import machineriesReducer from "./machineriesReducer"
export default machineriesReducer